import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { FiCalendar } from "react-icons/fi";
import { LIVE_URL } from "../../../../config/config";
import useAuthToken from "../../../../hooks/useAuthToken";
import Styles from "../css/BarChart.module.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "top",
      labels: {
        color: "#fff",
      },
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#fff",
      },
    },
    y: {
      ticks: {
        color: "#fff",
      },
    },
  },
};

const BarChart = () => {
  const { token, loading } = useAuthToken();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("monthly");
  const [year, setYear] = useState(new Date().getFullYear());
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!token || loading) return;

    const fetchChartData = async () => {
      try {
        const response = await fetch(
          `${LIVE_URL}/admin/dashboard/users-data?filter=${view}&year=${year}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();

        if (result?.data && typeof result.data === "object") {
          const sortedEntries = Object.entries(result.data).sort(
            ([a], [b]) => Number(a) - Number(b)
          );

          const labels = sortedEntries.map(([key]) => key);
          const values = sortedEntries.map(([, value]) => value);
          setChartData({
            labels,
            datasets: [
              {
                label: "Users",
                data: values,
                borderColor: "#e94057",
                backgroundColor: "#e94057",
                tension: 0,
                fill: false,
              },
            ],
          });
        } else {
          setChartData(null);
        }
      } catch (err) {
        console.error("Chart API error:", err);
        setChartData(null);
      }
    };

    fetchChartData();
  }, [view, year, token, loading]);

  return (
    <>
      <div className={Styles.controls}>
        <h2>Monthly Login User</h2>

        <div className={Styles.controls_btn}>
          {/* <button onClick={() => setView("yearly")}>Yearly</button> */}
          <button onClick={() => setView("monthly")}>Monthly</button>
          {/* <button onClick={() => setView("weekly")}>Daily</button> */}
        </div>

        <div className={Styles.year_select}>
          <div className={Styles.dropdown_wrapper}>
            <div
              className={Styles.dropdown_selected}
              onClick={() => setOpen(!open)}
            >
              <span className={Styles.year_text}>{year}</span>
              <span className={Styles.dropdown_arrow}>{open ? "▲" : "▼"}</span>
            </div>

            {open && (
              <div className={Styles.dropdown_list}>
                {[2024, 2025, 2026].map((yr) => (
                  <div
                    key={yr}
                    className={`${Styles.dropdown_item} ${
                      year === yr ? Styles.selected : ""
                    }`}
                    onClick={() => {
                      setYear(yr);
                      setOpen(false);
                    }}
                  >
                    <span className={Styles.icon}>
                      <FiCalendar />
                    </span>
                    <span>{yr}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {chartData && <Line data={chartData} options={options} />}
    </>
  );
};

export default BarChart;
